import PropTypes from 'prop-types';
import AppShell from 'components/Layout/AppShell';
import CardsCarousel from 'components/CardsCarousel/CardsCarousel';

/**
 * En mobile/tablet: usa el CardsCarousel existente (Swiper horizontal).
 * En desktop (lg+): se envuelve en AppShell 'default' para alinear el ancho
 * con el resto del Home (UserBox/ShopBox) y evitar que la sección sobresalga.
 * CardsCarousel maneja el responsive de slides por breakpoint Swiper.
 */
const CardsCarouselBlock = ({ value, blockProps = {} }) => (
  <section className='cms-block cms-block--cards-carousel py-6 md:py-6 lg:py-8'>
    <AppShell variant='default'>
      <CardsCarousel
        title={value?.title}
        link={value?.link}
        cards={(value?.items || []).map((item) => ({
          id: item.id,
          ...item.value,
        }))}
        {...blockProps}
      />
    </AppShell>
  </section>
);

CardsCarouselBlock.propTypes = {
  value: PropTypes.shape({
    title: PropTypes.string,
    link: PropTypes.object,
    items: PropTypes.array,
  }).isRequired,
  blockProps: PropTypes.object,
};

export default CardsCarouselBlock;
